import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../pages/assessment';
import { selectPatient } from '../../../redux/assessment';
import { selectPresentMeta, updateMeta } from '../../../redux/meta';
import { selectIsGuardian } from '../../../redux/session';
import MedicalInfoIntro from '../screens/medical-info-intro';
import { TITLE_COLORS } from '../shared/redux-flow-container';

const MedicalInfoIntroScreenWrapper = () => {
  const dispatch = useAppDispatch();

  const onContinue = () => {
    dispatch(updateMeta());
  };

  const patient = useSelector(selectPatient);
  const meta = useSelector(selectPresentMeta);
  const isGuardian = useSelector(selectIsGuardian);

  return (
    <MedicalInfoIntro
      patientPreferredName={patient.preferredName}
      isGuardian={isGuardian}
      titleColor={TITLE_COLORS[meta.assessmentSection]}
      onContinue={onContinue}
    />
  );
};

export default MedicalInfoIntroScreenWrapper;
